import React from 'react';

import { H4 } from '@zooplus/ui-components';
import { Currency, formatPrice, useSiteContext } from '@zooplus/commons-lang';

import styles from './AmountLabel.module.scss';

interface AmountLabelProps {
  amount: number;
  currency: string;
}

export const AmountLabel: React.FC<AmountLabelProps> = (props: AmountLabelProps) => {
  const { locale } = useSiteContext();

  return (
    <span className={styles.amountLabelWrapper}>
      <H4 className={styles.amount}>
        {formatPrice(props.amount, locale, props.currency as Currency)}
      </H4>
    </span>
  );
};
